import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Condu.", -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "CE", -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "CDG", -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ReportSheetsSkeleton = _resolveComponent("ReportSheetsSkeleton")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_SiteSelector = _resolveComponent("SiteSelector")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_SummariesExportModal = _resolveComponent("SummariesExportModal")!
  const _component_ContentSidebarWrapper = _resolveComponent("ContentSidebarWrapper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('report_sheets.main_page.screen_title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "secondary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reload()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.refreshIcon }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.is_mobile)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                key: 0,
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_searchbar, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                    placeholder: _ctx.$t('report_sheets.main_page.filters.search_placeholder')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ContentSidebarWrapper, {
            class: _normalizeClass(_ctx.is_mobile ? _ctx.$style['custom-height'] : ''),
            side: "left"
          }, {
            content: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_ReportSheetsSkeleton)
                  ]))
                : (_ctx.reportSheets.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportSheets, (reportSheet) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: reportSheet.uuid,
                          sheet: reportSheet,
                          button: true,
                          onClick: ($event: any) => (_ctx.$router.push('/report-sheets/' + reportSheet.uuid))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.$style['inner'])
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("h4", null, _toDisplayString(reportSheet.title), 1),
                                (reportSheet.total_cost)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('report_sheets.main_page.total')) + " : " + _toDisplayString(reportSheet.total_cost) + "€ ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style['right'])
                              }, [
                                (reportSheet.status == 'pending')
                                  ? _withDirectives((_openBlock(), _createElementBlock("p", { key: 0 }, _toDisplayString(_ctx.$t('report_sheets.main_page.filters.status.options.pending')), 513)), [
                                      [_vShow, false]
                                    ])
                                  : _createCommentVNode("", true),
                                (reportSheet.status == 'validated')
                                  ? _withDirectives((_openBlock(), _createElementBlock("p", {
                                      key: 1,
                                      class: _normalizeClass(_ctx.$style['raport-validated'])
                                    }, _toDisplayString(_ctx.$t('report_sheets.main_page.filters.status.options.validated')), 3)), [
                                      [_vShow, false]
                                    ])
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", null, _toDisplayString(_ctx.moment(reportSheet.created_at).format("DD/MM/YYYY")), 1),
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.$style['user-pictures'])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportSheet.roles, (role) => {
                                    return (_openBlock(), _createElementBlock("img", {
                                      key: role.user.uuid,
                                      src: role.user.profile_picture??'',
                                      loading: "lazy",
                                      alt: "Profile picture"
                                    }, null, 8, _hoisted_4))
                                  }), 128))
                                ], 2),
                                _createElementVNode("ul", {
                                  class: _normalizeClass(_ctx.$style['report-sheet-validation-status'])
                                }, [
                                  _createElementVNode("li", {
                                    class: _normalizeClass(reportSheet.validated_by_site_supervisor ? _ctx.$style['validated'] : _ctx.$style['waiting'])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.$style['status']),
                                      style: {"display":"flex","align-items":"center"}
                                    }, [
                                      _createVNode(_component_ion_icon, {
                                        size: "small",
                                        icon: reportSheet.validated_by_site_supervisor ? _ctx.checkmarkCircleOutline : _ctx.closeCircleOutline
                                      }, null, 8, ["icon"]),
                                      _hoisted_5,
                                      _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$t('users.roles.site-supervisor')), 513), [
                                        [_vShow, false]
                                      ])
                                    ], 2),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.$style['user-initials-wrapper'])
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportSheet.roles.filter(r => r.role === 'site-supervisor'), (role) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: role.user.uuid
                                        }, [
                                          (role.user.profile_picture)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: role.user.profile_picture,
                                                alt: "Profile picture",
                                                class: _normalizeClass(_ctx.$style['role-user-picture'])
                                              }, null, 10, _hoisted_6))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ], 2)
                                  ], 2),
                                  _createElementVNode("li", {
                                    class: _normalizeClass(reportSheet.validated_by_site_manager ? _ctx.$style['validated'] : _ctx.$style['waiting'])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.$style['status']),
                                      style: {"display":"flex","align-items":"center"}
                                    }, [
                                      _createVNode(_component_ion_icon, {
                                        size: "small",
                                        icon: reportSheet.validated_by_site_manager ? _ctx.checkmarkCircleOutline : _ctx.closeCircleOutline
                                      }, null, 8, ["icon"]),
                                      _hoisted_7,
                                      _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$t('users.roles.site-manager')), 513), [
                                        [_vShow, false]
                                      ])
                                    ], 2),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.$style['user-initials-wrapper'])
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportSheet.roles.filter(r => r.role === 'site-manager'), (role) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: role.user.uuid
                                        }, [
                                          (role.user.profile_picture)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: role.user.profile_picture,
                                                alt: "Profile picture",
                                                class: _normalizeClass(_ctx.$style['role-user-picture'])
                                              }, null, 10, _hoisted_8))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ], 2)
                                  ], 2),
                                  _createElementVNode("li", {
                                    class: _normalizeClass(reportSheet.validated_by_manager ? _ctx.$style['validated'] : _ctx.$style['waiting'])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.$style['status']),
                                      style: {"display":"flex","align-items":"center"}
                                    }, [
                                      _createVNode(_component_ion_icon, {
                                        size: "small",
                                        icon: reportSheet.validated_by_manager ? _ctx.checkmarkCircleOutline : _ctx.closeCircleOutline
                                      }, null, 8, ["icon"]),
                                      _hoisted_9,
                                      _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$t('users.roles.manager')), 513), [
                                        [_vShow, false]
                                      ])
                                    ], 2),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.$style['user-initials-wrapper'])
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportSheet.roles.filter(r => r.role === 'manager'), (role) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: role.user.uuid
                                        }, [
                                          (role.user.profile_picture)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: role.user.profile_picture,
                                                alt: "Profile picture",
                                                class: _normalizeClass(_ctx.$style['role-user-picture'])
                                              }, null, 10, _hoisted_10))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ], 2)
                                  ], 2)
                                ], 2)
                              ], 2)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["sheet", "onClick"]))
                      }), 128)),
                      _createVNode(_component_ion_infinite_scroll, {
                        id: "infinite-scroll",
                        threshold: "500px",
                        onIonInfinite: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadNextPage($event)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_infinite_scroll_content)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_ion_text, {
                        class: "ion-text-center",
                        color: "medium"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('report_sheets.main_page.no_result')), 1)
                        ]),
                        _: 1
                      })
                    ]))
            ]),
            sidebar: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style['filters-content'])
              }, [
                (!_ctx.is_mobile)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([_ctx.$style['filter-item-wrapper'], ""])
                    }, [
                      _createVNode(_component_ion_searchbar, {
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                        class: _normalizeClass(_ctx.$style['filter-item-search']),
                        placeholder: _ctx.$t('report_sheets.main_page.filters.search_placeholder'),
                        color: "light",
                        mode: "ios"
                      }, null, 8, ["modelValue", "class", "placeholder"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style['filter-item-wrapper'])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style['filter-item'])
                  }, [
                    _createVNode(_component_ion_button, {
                      color: "light",
                      expand: "full",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open_site_selector = true))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['button-inner'])
                        }, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.mapIcon,
                            color: "medium"
                          }, null, 8, ["icon"]),
                          (!_ctx.site?.name)
                            ? (_openBlock(), _createBlock(_component_ion_text, {
                                key: 0,
                                color: "medium"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("orders.filters.site")), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                _createTextVNode(_toDisplayString(_ctx.text.truncate(_ctx.site?.name, 26)) + " ", 1),
                                _createVNode(_component_ion_icon, {
                                  class: _normalizeClass(_ctx.$style['remove-filter']),
                                  icon: _ctx.closeIcon,
                                  color: "dark",
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.site = null), ["stop"]))
                                }, null, 8, ["class", "icon"])
                              ]))
                        ], 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_SiteSelector, {
                      active: _ctx.open_site_selector,
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.site = $event.value)),
                      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.open_site_selector = false))
                    }, null, 8, ["active"])
                  ], 2)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style['filter-item-wrapper'])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style['filter-item'])
                  }, [
                    _createVNode(_component_ion_select, {
                      modelValue: _ctx.status,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.status) = $event)),
                      multiple: true,
                      placeholder: _ctx.$t('report_sheets.main_page.filters.status.label'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: "validated_by_site_supervisor" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('report_sheets.main_page.filters.status.options.validated_by_site_supervisor') || 'Validated by site supervisor'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "validated_by_site_manager" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('report_sheets.main_page.filters.status.options.validated_by_site_manager') || 'Validated by site manager'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "validated_by_manager" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('report_sheets.main_page.filters.status.options.validated_by_manager') || 'Validated by manager'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ], 2)
                ], 2),
                (_ctx.user.canExportSummaries)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(_ctx.$style['filter-item-wrapper'])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style['filter-item'])
                      }, [
                        _createVNode(_component_ion_button, {
                          color: "primary",
                          expand: "full",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.open_export_modal = true))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.$style['button-inner'])
                            }, [
                              _createVNode(_component_ion_icon, { icon: _ctx.downloadIcon }, null, 8, ["icon"]),
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('report_sheets.main_page.export_summaries.button')), 1)
                                ]),
                                _: 1
                              })
                            ], 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_SummariesExportModal, {
                          active: _ctx.open_export_modal,
                          search: _ctx.search,
                          site: _ctx.site,
                          status: _ctx.status,
                          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.open_export_modal = false))
                        }, null, 8, ["active", "search", "site", "status"])
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}